/**
 * @generated SignedSource<<690ebda96db0b85b1573f3f7a2cb3b01>>
 * @relayHash 22b3a08a1d1b334ad3a352d3e5fe06b6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2d1a71f35abd47c744598712c297fbc813c370680804419fece29b5a9527db42

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type agentParticipants_agentByIdQuery$variables = {
  agentId: string;
};
export type agentParticipants_agentByIdQuery$data = {
  readonly agentStudio_agentById: {
    readonly identityAccount?: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"avatarRelay_user">;
    } | null;
  } | null;
};
export type agentParticipants_agentByIdQuery = {
  response: agentParticipants_agentByIdQuery$data;
  variables: agentParticipants_agentByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "agentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "agentParticipants_agentByIdQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_agentById",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "identityAccount",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "avatarRelay_user"
                  }
                ]
              }
            ],
            "type": "AgentStudioAssistant"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentParticipants_agentByIdQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_agentById",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "identityAccount",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isUser"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "picture"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "appType"
                      }
                    ],
                    "type": "AppUser"
                  },
                  (v4/*: any*/)
                ]
              }
            ],
            "type": "AgentStudioAssistant"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2d1a71f35abd47c744598712c297fbc813c370680804419fece29b5a9527db42",
    "metadata": {},
    "name": "agentParticipants_agentByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0992fd3d08b0ab379cf5ae7de9b6d997";

export default node;
